export interface MuteOptions {
  mutePseudoClasses?: boolean;
  muteIntercom?: boolean;
}

export function muteConsole({
  mutePseudoClasses = true,
  muteIntercom = true,
}: MuteOptions = {}) {
  if (import.meta.env.MODE !== 'development') {
    return;
  }
  const log = console.error.bind(console);
  const warn = console.warn.bind(console);
  console.error = (...args) => {
    if (
      mutePseudoClasses &&
      args.indexOf('The pseudo class') &&
      args.indexOf(
        'is potentially unsafe when doing server-side rendering. Try changing it to',
      )
    ) {
      return;
    }
    // dirty hack for https://github.com/devrnt/react-use-intercom/issues/726
    // we are going to migrate to Zendesk in the near future
    if (muteIntercom && args.indexOf('[react-use-intercom]')) {
      return;
    }
    log(...args);
  };
  console.warn = (...args) => {
    if (muteIntercom && args.indexOf('[react-use-intercom]')) {
      return;
    }
    warn(...args);
  };
}
